export type ViewPagePerformanceModeConfig = {
	isEnabled: boolean;
	nodeCountThreshold: number;
	learnMoreLink: string;
};

// Consumers use the document decision, independently of the temporary rollout configuration.
export type ViewPagePerformanceModeState = Omit<ViewPagePerformanceModeConfig, 'isEnabled'> & {
	contentId: string;
	nodeCount: number;
	isActive: boolean;
};

export type ViewPagePerformanceModeInput = {
	contentId: string;
	documentContentId: string | null | undefined;
	nodeCount: number;
	isSupportedView: boolean;
};

export const isViewPagePerformanceModeDocumentReady = ({
	contentId,
	documentContentId,
	isSupportedView,
}: ViewPagePerformanceModeInput): boolean =>
	isSupportedView && Boolean(contentId) && documentContentId === contentId;

const getLearnMoreLink = (link: string): string => {
	try {
		const url = new URL(link);
		return url.protocol === 'https:' ? url.href : '';
	} catch {
		return '';
	}
};

export const evaluateViewPagePerformanceMode = (
	input: ViewPagePerformanceModeInput,
	config: ViewPagePerformanceModeConfig,
): ViewPagePerformanceModeState | null => {
	if (
		config.isEnabled !== true ||
		!isViewPagePerformanceModeDocumentReady(input) ||
		!Number.isSafeInteger(config.nodeCountThreshold) ||
		config.nodeCountThreshold <= 0 ||
		!Number.isSafeInteger(input.nodeCount) ||
		input.nodeCount < 0
	) {
		return null;
	}

	return {
		contentId: input.contentId,
		nodeCount: input.nodeCount,
		nodeCountThreshold: config.nodeCountThreshold,
		learnMoreLink: getLearnMoreLink(config.learnMoreLink),
		isActive: input.nodeCount >= config.nodeCountThreshold,
	};
};
